import { CommunicationChartNodeKindEnum } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeKind';
import { getRenderedCommunicationChartNodeRadiusPx, isFiniteCommunicationChartPosition } from '@web/components/CommunicationNetworkGraph/graph/communicationChartArrowGeometry';
import { COMMUNICATION_CHART_COLORS, COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_CLEARANCE_BELOW_NODE_PX, COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_FONT, COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_LINE_HEIGHT_PX, COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_MARGIN_PX } from '@web/components/CommunicationNetworkGraph/graph/communicationChartConstants';
var drawSectionLabel = function (ctx, text, x, y, textBaseline) {
    ctx.save();
    ctx.fillStyle = COMMUNICATION_CHART_COLORS.label;
    ctx.font = COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_FONT;
    ctx.textAlign = 'center';
    ctx.textBaseline = textBaseline;
    ctx.fillText(text, x, y);
    ctx.restore();
};
var resolveNodeSectionLabelAnchorY = function (node) {
    var position = node.renderedPosition();
    if (!isFiniteCommunicationChartPosition(position)) {
        return null;
    }
    var radius = getRenderedCommunicationChartNodeRadiusPx(node);
    return (position.y +
        radius +
        COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_CLEARANCE_BELOW_NODE_PX);
};
var resolveGroupLabelAnchorX = function (nodes, side) {
    var anchorX = side === 'left' ? Infinity : -Infinity;
    var count = 0;
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var node = nodes_1[_i];
        var position = node.renderedPosition();
        if (!isFiniteCommunicationChartPosition(position)) {
            continue;
        }
        anchorX =
            side === 'left'
                ? Math.min(anchorX, position.x)
                : Math.max(anchorX, position.x);
        count += 1;
    }
    return count > 0 ? anchorX : null;
};
var resolveGroupSectionLabelAnchorY = function (nodes) {
    var anchorY = -Infinity;
    for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
        var node = nodes_2[_i];
        var nodeAnchorY = resolveNodeSectionLabelAnchorY(node);
        if (nodeAnchorY == null) {
            continue;
        }
        anchorY = Math.max(anchorY, nodeAnchorY);
    }
    return Number.isFinite(anchorY) ? anchorY : null;
};
var drawSectionLabelBelowGroup = function (ctx, nodes, text, side) {
    var anchorX = resolveGroupLabelAnchorX(nodes, side);
    var anchorY = resolveGroupSectionLabelAnchorY(nodes);
    if (anchorX == null || anchorY == null) {
        return;
    }
    drawSectionLabel(ctx, text, anchorX, anchorY + COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_MARGIN_PX, 'top');
};
var drawSectionLabelBelowNode = function (ctx, node, text) {
    var position = node.renderedPosition();
    if (!isFiniteCommunicationChartPosition(position)) {
        return;
    }
    var radius = getRenderedCommunicationChartNodeRadiusPx(node);
    drawSectionLabel(ctx, text, position.x, position.y + radius + COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_MARGIN_PX, 'top');
};
var isCommunicationChartEmployeeTeammateNode = function (node) {
    return node.hasClass('personNode') &&
        !node.hasClass('employeeFocusPerson') &&
        !node.hasClass(CommunicationChartNodeKindEnum.CrossTeam);
};
var isCommunicationChartEmployeeCrossTeamNode = function (node) {
    return node.hasClass('personNode') &&
        node.hasClass(CommunicationChartNodeKindEnum.CrossTeam);
};
export var isCommunicationChartEmployeeSectionLabelsActive = function (cy) {
    return Boolean(cy.scratch('employeeSectionLabels')) &&
        cy.nodes('.employeeFocusPerson').length > 0;
};
export var resolveCommunicationChartEmployeeSectionLabelPaddingPx = function () {
    return COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_CLEARANCE_BELOW_NODE_PX +
        COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_MARGIN_PX +
        COMMUNICATION_CHART_EMPLOYEE_SECTION_LABEL_LINE_HEIGHT_PX +
        4;
};
export var drawCommunicationChartEmployeeSectionLabels = function (cy, ctx) {
    var labels = cy.scratch('employeeSectionLabels');
    if (!labels || !isCommunicationChartEmployeeSectionLabelsActive(cy)) {
        return;
    }
    var teammateNodes = cy
        .nodes('.personNode')
        .filter(isCommunicationChartEmployeeTeammateNode)
        .toArray();
    var crossTeamNodes = cy
        .nodes('.personNode')
        .filter(isCommunicationChartEmployeeCrossTeamNode)
        .toArray();
    var externalNode = cy.nodes('.external').first();
    if (teammateNodes.length > 0) {
        drawSectionLabelBelowGroup(ctx, teammateNodes, labels.teammates, 'left');
    }
    if (crossTeamNodes.length > 0) {
        drawSectionLabelBelowGroup(ctx, crossTeamNodes, labels.crossTeamColleagues, 'right');
    }
    if (!externalNode.empty()) {
        drawSectionLabelBelowNode(ctx, externalNode, labels.external);
    }
};
